/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD (Register as an anonymous module)
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// Node/CommonJS
		module.exports = factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (arguments.length > 1 && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {},
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling $.cookie().
			cookies = document.cookie ? document.cookie.split('; ') : [],
			i = 0,
			l = cookies.length;

		for (; i < l; i++) {
			var parts = cookies[i].split('='),
				name = decode(parts.shift()),
				cookie = parts.join('=');

			if (key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));
$(function() { 
$(".fancybox").fancybox();
  $('.product_form .select select').change(function() {
    var price = $('option:selected', this).attr('data-price');
    var compare_price = $('option:selected', this).attr('data-compare-price');
  //  var $addToCartForm = $(this).closest('form'); 
    $(this).parents('.grid-product').find('.grid-product__price--sale').html(price);
    $(this).parents('.grid-product').find('.grid-product__price--original').html(compare_price);

  });    
  
 // Read a cookie
console.log($.cookie('price_show')); // => 'the_value' 
 
  $('.hide-details').on('click', function() {
    var price_text = $(this).attr('data-show');
    $('.my_prod').slideToggle();
    $('.grid-product__price').slideToggle();    
    $('.hide-details').toggleClass("pressed");
     $.cookie('price_show', 1, { expires: 7 });
    if($(this).hasClass("pressed")) {
     $.cookie('price_show', 0, { expires: 7 });
    }
    console.log($.cookie('price_show'));
  }); 
  if($.cookie('price_show') == 0 ) {
  $('.hide-details').addClass("pressed");
    $('.my_prod').hide(); 
    $('.grid-product__price').hide(); 
  }
  /* Custom select design  variant_id */   
  $('#CollectionSection .grid-product').each(function() {
    var product_id = $(this).attr('data-product-id');
    var pp = '.product-'+product_id;
    var product_cl = $(pp)
    $(pp +' .drop-down').append('<div class="button"></div>');     
    $(pp +' .drop-down').append('<ul class="select-list"></ul>');     
    $(pp +' .drop-down select option').each(function() {    
      var vg = $(this).attr('variant-image');     
      var bg = $(this).attr('background-image'); 
      var sku = $(this).attr('data-sku'); 
      var available = $(this).attr('data-available'); 
      var price = $(this).attr('data-price'); 
      var compare_price = $(this).attr('data-compare-price'); 
      var value = $(this).attr('value');     
      $(pp +' .select-list').append('<li class="clsAnchor" ><span data-product="'+product_id+'" data-available="'+available+'" data-sku="' + sku + '" data-price="' + price + '"  data-compare-price="' + compare_price + '" value="' + jQuery(this).val() + '" class="' + jQuery(this).attr('class') + '" style="background-repeat: no-repeat;background-size: 20px 20px;padding-left: 36px;background-image:url(' + bg + ')" background-image="'+bg+'" variant-image="'+vg+'">' + $(this).text() + '</span></li>');    
    });     
    $(pp +' .drop-down .button').html('<a href="javascript:void(0);" class="select-list-link"><span style="background-repeat: no-repeat;background-size: 20px 20px;padding-left: 26px;background-image:url(' + $(pp +' .drop-down select').find(':selected').attr('background-image') + ')">' + $(pp +' .drop-down select').find(':selected').text() + '</span>' + '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></a>');    
    
    $(pp +' .drop-down ul li').each(function() {    
      if ($(this).find('span').text() == $(pp +' .drop-down select').find(':selected').text()) {   
        $(this).addClass('active');   
      }       
    });
  });  
  $('.drop-down .select-list span').on('click', function() {           
    var dd_text = $(this).text();   
    var v_img = $(this).attr('variant-image');
    var dd_img = $(this).attr('background-image');  
    var dd_val = $(this).attr('value');    
    var price = $(this).attr('data-price');
      var available = $(this).attr('data-available'); 
    var product_id = $(this).attr('data-product');
    var compare_price = $(this).attr('data-compare-price');  
    $(this).parents('.grid-product').find('.grid-product__price--sale').html(price);
    $(this).parents('.grid-product').find('.grid-product__price--original').html(compare_price);
    $(this).parents('.drop-down').find('.button').html('<a href="javascript:void(0);" class="select-list-link"><span style="background-repeat: no-repeat;background-size: 20px 20px;padding-left: 26px;background-image:url(' + dd_img + ')">' + dd_text + '</span>' + '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></a>');       
    $(this).parent().removeClass('active');     
    $(this).parent().addClass('active');    
    var pp = '#product-select-'+product_id+'collection-template'; 
    $('.drop-down select[name=options]').val( dd_val );  
    $('.drop-down .select-list li').slideUp();  
    $(pp).val(dd_val).change();
    var v_image = '.product-'+product_id+' .grid-product__image-mask img';
    var v_available = '.product-'+product_id+' .product__inventory';
    console.log(v_img)
    $(v_available).html(available);
  /*  if(typeof WSAIO !== "undefined" && typeof WSAIO.productDiscount === "function"){
      var valuex= dd_val;
      var handle=$(this).parents('.grid__item.grid-product').find('.my_coll').attr('product_handle');
      jQuery.getJSON('/products/'+handle+'.js', function(product) {
        var curent_product=product;
        var _indx = curent_product.variants.findIndex(function(x){return x.id == valuex})
        console.log(curent_product.variants[_indx]);
        setTimeout(function(){
          WSAIO.variantChange(curent_product.variants[_indx] , '.my_coll' , curent_product);
          WSAIO.variantChange(curent_product.variants[_indx] , '.my_coll' , curent_product);
          WSAIO.regularDiscount({
            template: 'collection',
            product_id: curent_product.id,
            product_handle: curent_product.handle,
            variant_id:  curent_product.variants[_indx].id,
            variant_sku: curent_product.variants[_indx].sku,
            variant_price: curent_product.variants[_indx].price,
            variant_compare_at_price: curent_product.variants[_indx].compare_at_price
          });
        },1000)
      })
    }*/

    
    $(v_image).attr('src',v_img);
    $(v_image).attr('srcset','');
     $(this).parent().parent().find('.select-list').hide();  
  });        
  $('.drop-down .button').on('click','a.select-list-link', function() {       
    $(this).parent().parent().find('.select-list').slideToggle('fast');   
  });   
    $(document).on('click', '.template-collection .js-qty__adjust', function() {
        var $this = $(this),
            $input = $(this).siblings('input'),
            val = parseInt($input.val()),
            valMax = 100000000000000000000000000000,
            valMin = $input.attr('min') || 0;

        if ($input.attr('max') != null){
          valMax = $input.attr('max');
        }

        if(isNaN(val) || val < valMin) {
            $input.val(valMin);
            return false;
        } else if (val > valMax) {
            $input.val(valMax);
            return false;
        }

        if($this.data('func') == 'plus') {
            if(val < valMax) $input.val(val + 1);
        } else {
            if(val > valMin) $input.val(val - 1); 
        }
        $input.trigger('change');

    }); 
  /* End */   
  var quantity = $('.variant-quantity');
  quantity.bind('change', function() {
    console.log('Bind:'+$(this).val());
    if($(this).val() != "") {
      $(this).parents('.product-variant-list').find('button.add-to-cart').attr('disabled', false); 
      $(this).parents('.product-variant-list').find('.customer-reference').attr('disabled', false);
    } else {
      $(this).parents('.product-variant-list').find('button.add-to-cart').attr('disabled', true); 
      $(this).parents('.product-variant-list').find('.customer-reference').attr('disabled', true);    
    }
  });
 
 // quantity.keydown(function(e) {
  quantity.bind('keyup change', function() {
    console.log('keydown'+$(this).val());
    if($(this).val() != "") {
      $(this).parents('.product-variant-list').find('button.add-to-cart').attr('disabled', false);  
      $(this).parents('.product-variant-list').find('.customer-reference').attr('disabled', false);
    } else {
      $(this).parents('.product-variant-list').find('button.add-to-cart').attr('disabled', true); 
      $(this).parents('.product-variant-list').find('.customer-reference').attr('disabled', true);    
    }
  });
});  
